module.exports = __webpack_public_path__ + "static/img/android1.1a48efe0.jpg";